import { Nullable } from '@/models/Model';

import normalize from './normalize';

export default function percentage(
  decimal?: Nullable<number>,
  fractionDigits?: number,
): number {
  return normalize((decimal ?? 0) * 100, fractionDigits);
}
